import terminalVenda from "@/modules/Terminais/pages/Index";
import Create from "@/modules/Terminais/pages/Create";
import Update from "@/modules/Terminais/pages/Update";

export default [
  {
    name: "terminalVenda",
    path: "/terminalVenda",
    component: terminalVenda,
    meta: { title: "Terminais de Venda" },
  },
  {
    name: "terminaisNovo",
    path: "/terminais/novo",
    component: Create,
    meta: { title: "Terminais de Venda" },
  },
  {
    name: "terminaisUpdate",
    path: "/terminais/:uuid_terminal/editar",
    component: Update,
    meta: { title: "Terminais de Venda" },
  },
];
